module.exports = "https://r.zoocdn.com/_next/static/images/hero-600-7b4c38bd08cf9fefd2e3cf10838ab3f9.jpg";